import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import ChatBoxComp from "../../components/ChatBoxComp";
import { AppContext } from "../../contexts/AppContext";

const ChatBox: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <ChatBoxComp />;
};

export default ChatBox;
